import React from 'react';
import PropTypes from 'prop-types';
import Students from './Students';
import Creator from './Creator';
import useProjectTags from '../../../hooks/useProjectTags';
import TagTypes from '../../../constants/TagTypes';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import MissingField from '../ProjectMissingField';

export default function Participants(props) {
  const { project } = props;

  const projectParticipants = useProjectTags(project, TagTypes.Participant);

  if (projectParticipants.state === PayloadStates.FETCHING) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  if (projectParticipants.data.length === 0) {
    return (
      <MissingField name="Participants" />
    );
  }

  return (
    <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
      <div className="w-full">
        <Creator project={project} />
      </div>
      <div className="w-full">
        <Students project={project} />
      </div>
    </div>
  );
};
